import React from 'react'
import sonImage from '@/assets/img/son.jpeg'
import { Link } from 'react-router-dom';

const Info2 = () => {
  return (
    <div class="py-16">
    <div class="m-auto px-6 text-gray-600 md:px-12 xl:px-16">
      <div class="lg:bg-gray-100 md:bg-gray-100 sm:bg-gray-100 dark:lg:bg-darker lg:p-16 rounded-3xl space-y-6 md:flex md:gap-6 justify-center md:space-y-0 lg:items-center">
        <div class="md:w-5/12 lg:w-1/2">
          <img
            src={sonImage}
            alt="image"
            loading="lazy"
            class="rounded-3xl w-full max-w-lg mx-auto"
          />
        </div>
        <div class="md:w-7/12 lg:w-1/2">
          <h2 class="text-3xl font-bold text-gray-900 md:text-3xl dark:text-black">
            360 DEGREE EDUCATION
          </h2>
          <p class="my-8 text-gray-800 dark:text-gray-800">
            At APS, education transcends classroom boundaries. We empower our young champions to gain a comprehensive perspective on life and career paths through a variety of dynamic programs. From student exchange and immersion experiences to exhilarating excursions and hands-on science and engineering challenges, we ensure our students are well-prepared for the future. Our vibrant career fairs and diverse activities foster growth, creativity, and a passion for learning.
          </p>
          <Link
  to="/About"
  className="relative flex h-12 w-full items-center justify-center px-8 before:absolute before:inset-0 before:rounded-full before:bg-[#000C66] before:bg-gradient-to-b before:transition before:duration-300 hover:before:scale-105 active:duration-75 active:before:scale-95 dark:before:border-blue-700 dark:before:bg-[#000C66] sm:w-max"
>
  <span className="relative text-base font-semibold text-white dark:text-[white]">
    Learn more
  </span>
</Link>
        </div>
      </div>
    </div>
  </div>
  
  )
}

export default Info2
